import { formattedColorMaterial } from "../../../components/formatted/FormattedText";
import {
  buildAnomalyChartFromDelivery,
  buildMergedAnomalyChart,
} from "./buildAnomalyChartData";

function handleAnomalyList(typeAnomaly, t) {
  if (!typeAnomaly) return undefined;

  return Object.keys(typeAnomaly).map((type) => ({
    name: `${t(type)}${type === "sorting_errors" ? ` (${t("sum of the sorting errors chart salues")})` : ""}`,
    value: type,
    nameAndCount: `${t(type)} (${typeAnomaly[type]})`,
    color: formattedColorMaterial(type),
    count: typeAnomaly[type],
  }));
}

function normalizeCollection(collection, t) {
  if (!collection) return null;

  const objectList = handleAnomalyList(collection.objectDelivery, t);
  const mergedMaterials = objectList.flat().reduce((merged, material) => {
    merged[material.name] = {
      ...(merged[material.name] || { ...material }),
      count: (merged[material.name]?.count || 0) + material.count,
    };
    return merged;
  }, {});
  const mergedArray = Object.values(mergedMaterials);
  const objectCount = mergedArray.map((material) => material.count);
  const objectNames = mergedArray.map((material) => material.name);
  const objectColors = mergedArray.map((material) => material.color);

  return {
    numberOfAnomaly: collection.numberOfAnomaly || 0,
    totalVolumeSortingError: collection.totalVolumeSortingError || 0,
    totalWasteVolume: collection.totalWasteVolume || 0,
    numberOfStars: collection.numberOfStars || 0,
    historyCycle: collection.historyCurrent || [],
    container: collection,
    collectionFillingLevel: collection.collectionFillingLevel || 0,
    numberOfObjects: collection.numberOfObjects || 0,
    dataNumberOfObject: objectCount,
    labelObjectSeparate: objectNames,
    colorObject: objectColors,
  };
}

function mergeCollections(collections) {
  const merged = {
    numberOfAnomaly: 0,
    totalVolumeSortingError: 0,
    totalWasteVolume: 0,
    numberOfStars: 0,
    historyCycle: [],
    collectionFillingLevel: 0,
    numberOfObjects: 0,
    dataNumberOfObject: [],
    labelObjectSeparate: [],
    colorObject: [],
  };

  const materialMapObjects = {};

  collections.forEach((c) => {
    merged.numberOfAnomaly += c.numberOfAnomaly;
    merged.totalVolumeSortingError += c.totalVolumeSortingError;
    merged.totalWasteVolume += c.totalWasteVolume;
    merged.numberOfStars = Math.max(merged.numberOfStars, c.numberOfStars);
    merged.collectionFillingLevel = Math.max(
      merged.collectionFillingLevel,
      c.collectionFillingLevel,
    );
    merged.numberOfObjects += c.numberOfObjects;

    c.labelObjectSeparate.forEach((label, idx) => {
      if (!materialMapObjects[label]) {
        materialMapObjects[label] = {
          count: c.dataNumberOfObject[idx],
          color: c.colorObject[idx],
        };
      } else {
        materialMapObjects[label].count += c.dataNumberOfObject[idx];
      }
    });

    merged.historyCycle = merged.historyCycle.concat(c.historyCycle || []);
  });

  merged.labelObjectSeparate = Object.keys(materialMapObjects);
  merged.dataNumberOfObject = Object.keys(materialMapObjects).map(
    (k) => materialMapObjects[k].count,
  );
  merged.colorObject = Object.keys(materialMapObjects).map(
    (k) => materialMapObjects[k].color,
  );

  return merged;
}

export function buildCollectionRowChartData({
  timeLine,
  superContainerTimeLine,
  collectionData,
  t,
}) {
  let rawCollections = [];

  if (superContainerTimeLine) {
    const leftSide = superContainerTimeLine.find((i) =>
      i._value_image.includes("-L.jpeg"),
    );
    const collection =
      collectionData?.[`${leftSide?._measurement}_${leftSide?._time}`];
    rawCollections = collection || [];
  } else {
    const collection =
      collectionData[`${timeLine._measurement}_${timeLine._time}`];
    rawCollections = collection ? [collection] : [];
  }

  const collections = rawCollections
    .map((item) => normalizeCollection(item, t))
    .filter(Boolean);

  const anomalyChart =
    rawCollections.length > 1
      ? buildMergedAnomalyChart(rawCollections, t, formattedColorMaterial)
      : buildAnomalyChartFromDelivery(
          rawCollections[0]?.anomalyDelivery,
          rawCollections[0]?.numberOfAnomaly || 0,
          t,
          formattedColorMaterial,
        );

  const chartDataMerged =
    collections.length > 1 ? mergeCollections(collections) : collections[0];

  return {
    container: timeLine,
    superContainerTimeLine: superContainerTimeLine || null,
    ...chartDataMerged,
    dataAnomalyDelivery: anomalyChart.values,
    labelsAnomalyDelivery: anomalyChart.labels,
    colorAnomalyDelivery: anomalyChart.colors,
    numberOfAnomaly: anomalyChart.numberOfAnomaly,
    anomalyChartTotal: anomalyChart.chartTotal,
  };
}
